var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFailClose = function SvgFailClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 9.9 9.9M10.9 1 1 10.9",
    stroke: "#601311",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
export { SvgFailClose as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M1 1L10.8995 10.8995' stroke='%23601311' stroke-width='1.2' stroke-linecap='round'/%3E %3Cpath d='M10.8995 1L1 10.8995' stroke='%23601311' stroke-width='1.2' stroke-linecap='round'/%3E %3C/svg%3E";